// extracted by mini-css-extract-plugin
export default {"Credits":"Credits_Credits__30Ess","CreditsCredits":"Credits_CreditsCredits__0bxt7"};